import { createContext } from "react";

const commondataContext = createContext();

export default commondataContext;
